import { render } from "./RecordsNotFound.vue?vue&type=template&id=cc2d03c0&scoped=true"
import script from "./RecordsNotFound.vue?vue&type=script&lang=js"
export * from "./RecordsNotFound.vue?vue&type=script&lang=js"

import "./RecordsNotFound.vue?vue&type=style&index=0&id=cc2d03c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2d03c0"]])

export default __exports__